import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "../query/querykeys";
import ApiRequest from "../ApiRequest";
import type { ResponseType } from "../types/axiosResponseType";

type ClearResponse = ResponseType<null>;

export function useClearAllNotificationsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await ApiRequest.delete<ClearResponse>(`${requestURLs.notification}all`);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allNotification] });
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.notificationHistory] });
    },
  });
}
